<template>
    <div>
      <el-card class="box-card">
        <el-form :model="editForm" ref="editFormRef" label-width="170px">
          <el-form-item class="addAdminForm" label="团队名称">
            <el-input v-model="editForm.teamname"></el-input>
          </el-form-item>
          <el-form-item class="addAdminForm" label="团队长">
            <el-input v-model="editForm.teamlead"></el-input>
          </el-form-item>
          <el-form-item class="addAdminForm" label="业绩要求">
            <el-input v-model="editForm.yejiyaoqiu"></el-input>
          </el-form-item>
          <el-form-item class="addAdminForm" label="提成比例或方案">
            <el-input v-model="editForm.tichengbili"></el-input>
          </el-form-item>
          <el-form-item class="addAdminForm" label="备注">
            <el-input v-model="editForm.beizhu"></el-input>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clicksave">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  data () {
    return {
      editForm: {
        id: 0,
        teamname: '',
        teamlead: '',
        yejiyaoqiu: '',
        tichengbili: '',
        beizhu: ''
      }
    }
  },
  mounted () {
  },
  methods: {
    LoadData (row) {
      this.editForm.id = row.Id
      this.editForm.teamname = row.Teamname
      this.editForm.teamlead = row.Teamlead
      this.editForm.yejiyaoqiu = row.Yejiyaoqiu
      this.editForm.tichengbili = row.Tichengbili
      this.editForm.beizhu = row.Beizhu
    },
    clickreturn () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.apiEditErp6SaleBaseSalesTeam()
    },
    apiEditErp6SaleBaseSalesTeam: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      data = { ...data, ...that.editForm }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditErp6SaleBaseSalesTeam, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 365px;
}
</style>
